export default "__VITE_ASSET__17195251__"